import { Box, styled } from '@mui/material'

export const EmptyPlaceholderWrapper = styled(Box)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 25px;
`
